import { defineMessages } from 'react-intl';

export default defineMessages({
	completed: {
		id: 'listitem.button.completed',
		defaultMessage: "Study Completed",
	},
	expired: {
		id: 'listitem.button.expired',
		defaultMessage: "Study Expired",
	},
	complete_study: {
		id: 'listitem.button.complete_study',
		defaultMessage: "Complete Study",
	},
	watch_now: {
		id: 'listitem.button.watch_now',
		defaultMessage: "Watch Now",
	},
	error_group_join_failed: {
		id: 'listitem.error.group.join',
		defaultMessage: "Failed to join study",
	},
	error_groups_loading_failed: {
		id: 'listitem.error.groups.loading',
		defaultMessage: "Loading studies failed",
	},
	error_user_loading_failed: {
		id: 'listitem.error.user.loading',
		defaultMessage: "Loading user data failed",
	},
	error_user_update_failed: {
		id: 'listitem.error.user.update',
		defaultMessage: "Updating user data failed",
	},
});



// WEBPACK FOOTER //
// ./src/locales/listItems.js